export const HangUpCallIcon = ({ size = 18, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    {...props}
  >
    <g clip-path="url(#clip0_4753_17167)">
      <path
        d="M9.07852 28.9388L6.07852 25.9388C5.79888 25.6614 5.58026 25.3287 5.43666 24.9619C5.29305 24.5952 5.22763 24.2025 5.24457 23.809C5.26152 23.4155 5.36046 23.0298 5.53506 22.6768C5.70966 22.3237 5.95608 22.0111 6.25852 21.7587C9.67005 19.0159 13.6774 17.1116 17.9585 16.1987C21.91 15.3179 26.007 15.3179 29.9585 16.1987C34.2574 17.1175 38.2793 19.036 41.6986 21.7987C42.0001 22.0503 42.2459 22.3619 42.4204 22.7136C42.5949 23.0654 42.6943 23.4496 42.7122 23.8419C42.73 24.2342 42.666 24.6258 42.5242 24.992C42.3824 25.3582 42.166 25.6908 41.8886 25.9688L38.8886 28.9688C38.408 29.4588 37.7657 29.7575 37.0813 29.809C36.3968 29.8605 35.717 29.6614 35.1686 29.2488C34.0819 28.4153 32.9044 27.7075 31.6585 27.1388C31.1661 26.9154 30.748 26.5555 30.4538 26.1018C30.1595 25.6481 30.0016 25.1195 29.9985 24.5788V22.0387C26.0714 20.9588 21.9256 20.9588 17.9985 22.0387V24.5788C17.9955 25.1195 17.8375 25.6481 17.5433 26.1018C17.2491 26.5555 16.831 26.9154 16.3385 27.1388C15.0927 27.7075 13.9152 28.4153 12.8285 29.2488C12.2742 29.666 11.5859 29.865 10.8945 29.8078C10.2031 29.7506 9.55678 29.4413 9.07852 28.9388Z"
        stroke="white"
        stroke-width="2.82843"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4753_17167">
        <rect
          width="33.9412"
          height="33.9412"
          fill="white"
          transform="translate(48.0001 24) rotate(135)"
        />
      </clipPath>
    </defs>
  </svg>
);
